//endregion
// columns
export { default as DurationColumn } from '../lib/Scheduler/column/DurationColumn.js';
export { default as EventColorColumn } from '../lib/Scheduler/column/EventColorColumn.js';
export { default as ResourceCollapseColumn } from '../lib/Scheduler/column/ResourceCollapseColumn.js';
export { default as ResourceInfoColumn } from '../lib/Scheduler/column/ResourceInfoColumn.js';
export { default as ScaleColumn } from '../lib/Scheduler/column/ScaleColumn.js';
export { default as TimeAxisColumn } from '../lib/Scheduler/column/TimeAxisColumn.js';
export { default as VerticalTimeAxisColumn } from '../lib/Scheduler/column/VerticalTimeAxisColumn.js';
// crud
export { default as AbstractCrudManager } from '../lib/Scheduler/crud/AbstractCrudManager.js';
export { default as AbstractCrudManagerMixin } from '../lib/Scheduler/crud/AbstractCrudManagerMixin.js';
export { default as AbstractCrudManagerValidation } from '../lib/Scheduler/crud/mixin/AbstractCrudManagerValidation.js';
export { default as AjaxTransport } from '../lib/Scheduler/crud/transport/AjaxTransport.js';
export { default as JsonEncoder } from '../lib/Scheduler/crud/encoder/JsonEncoder.js';
// crud mixin
export { default as CrudManagerView } from '../lib/Scheduler/crud/mixin/CrudManagerView.js';
// data
export { default as AssignmentStore } from '../lib/Scheduler/data/AssignmentStore.js';
export { default as CrudManager } from '../lib/Scheduler/data/CrudManager.js';
export { default as DependencyStore } from '../lib/Scheduler/data/DependencyStore.js';
export { default as EventStore } from '../lib/Scheduler/data/EventStore.js';
export { default as ResourceStore } from '../lib/Scheduler/data/ResourceStore.js';
export { default as ResourceTimeRangeStore } from '../lib/Scheduler/data/ResourceTimeRangeStore.js';
export { default as TimeAxis } from '../lib/Scheduler/data/TimeAxis.js';
export { default as TimeRangeStore } from '../lib/Scheduler/data/TimeRangeStore.js';
// data util
export { default as AbstractRecurrenceIterator } from '../lib/Scheduler/data/util/recurrence/AbstractRecurrenceIterator.js';
export { default as DailyRecurrenceIterator } from '../lib/Scheduler/data/util/recurrence/DailyRecurrenceIterator.js';
export { default as EventDayIndex } from '../lib/Scheduler/data/util/EventDayIndex.js';
export { default as MonthlyRecurrenceIterator } from '../lib/Scheduler/data/util/recurrence/MonthlyRecurrenceIterator.js';
export { default as RecurrenceDayRuleEncoder } from '../lib/Scheduler/data/util/recurrence/RecurrenceDayRuleEncoder.js';
export { default as RecurrenceLegend } from '../lib/Scheduler/data/util/recurrence/RecurrenceLegend.js';
export { default as WeeklyRecurrenceIterator } from '../lib/Scheduler/data/util/recurrence/WeeklyRecurrenceIterator.js';
export { default as YearlyRecurrenceIterator } from '../lib/Scheduler/data/util/recurrence/YearlyRecurrenceIterator.js';
// data mixin
export { default as AssignmentStoreMixin } from '../lib/Scheduler/data/mixin/AssignmentStoreMixin.js';
export { default as AttachToProjectMixin } from '../lib/Scheduler/data/mixin/AttachToProjectMixin.js';
export { default as DependencyStoreMixin } from '../lib/Scheduler/data/mixin/DependencyStoreMixin.js';
export { default as EventStoreMixin } from '../lib/Scheduler/data/mixin/EventStoreMixin.js';
export { default as GetEventsMixin } from '../lib/Scheduler/data/mixin/GetEventsMixin.js';
export { default as PartOfBaseProject } from '../lib/Scheduler/data/mixin/PartOfBaseProject.js';
export { default as PartOfProject } from '../lib/Scheduler/data/mixin/PartOfProject.js';
export { default as ProjectConsumer } from '../lib/Scheduler/data/mixin/ProjectConsumer.js';
export { default as ProjectCrudManager } from '../lib/Scheduler/data/mixin/ProjectCrudManager.js';
export { default as RecurringEventsMixin } from '../lib/Scheduler/data/mixin/RecurringEventsMixin.js';
export { default as RecurringTimeSpansMixin } from '../lib/Scheduler/data/mixin/RecurringTimeSpansMixin.js';
export { default as ResourceStoreMixin } from '../lib/Scheduler/data/mixin/ResourceStoreMixin.js';
// data plugin
export { default as StoreTimeZonePlugin } from '../lib/Scheduler/data/plugin/StoreTimeZonePlugin.js';
// eventlayout
export { default as HorizontalLayoutPack } from '../lib/Scheduler/eventlayout/HorizontalLayoutPack.js';
export { default as HorizontalLayoutStack } from '../lib/Scheduler/eventlayout/HorizontalLayoutStack.js';
export { default as PackMixin } from '../lib/Scheduler/eventlayout/PackMixin.js';
// feature base
export { default as DragBase } from '../lib/Scheduler/feature/base/DragBase.js';
export { default as DragCreateBase } from '../lib/Scheduler/feature/base/DragCreateBase.js';
export { default as EditBase } from '../lib/Scheduler/feature/base/EditBase.js';
export { default as ResourceTimeRangesBase } from '../lib/Scheduler/feature/base/ResourceTimeRangesBase.js';
export { default as TimeSpanMenuBase } from '../lib/Scheduler/feature/base/TimeSpanMenuBase.js';
export { default as TooltipBase } from '../lib/Scheduler/feature/base/TooltipBase.js';
// feature
export { default as AbstractTimeRanges } from '../lib/Scheduler/feature/AbstractTimeRanges.js';
export { default as ColumnLines } from '../lib/Scheduler/feature/ColumnLines.js';
export { default as Dependencies } from '../lib/Scheduler/feature/Dependencies.js';
export { default as DependencyEdit } from '../lib/Scheduler/feature/DependencyEdit.js';
export { default as EventCopyPaste } from '../lib/Scheduler/feature/EventCopyPaste.js';
export { default as EventDrag } from '../lib/Scheduler/feature/EventDrag.js';
export { default as EventDragCreate } from '../lib/Scheduler/feature/EventDragCreate.js';
export { default as EventDragSelect } from '../lib/Scheduler/feature/EventDragSelect.js';
export { default as EventEdit } from '../lib/Scheduler/feature/EventEdit.js';
export { default as EventFilter } from '../lib/Scheduler/feature/EventFilter.js';
export { default as EventMenu } from '../lib/Scheduler/feature/EventMenu.js';
export { default as EventNonWorkingTime } from '../lib/Scheduler/feature/EventNonWorkingTime.js';
export { default as EventResize } from '../lib/Scheduler/feature/EventResize.js';
export { default as EventTooltip } from '../lib/Scheduler/feature/EventTooltip.js';
export { default as GroupSummary } from '../lib/Scheduler/feature/GroupSummary.js';
export { default as HeaderZoom } from '../lib/Scheduler/feature/HeaderZoom.js';
export { default as Labels } from '../lib/Scheduler/feature/Labels.js';
export { default as NonWorkingTime } from '../lib/Scheduler/feature/NonWorkingTime.js';
export { default as Pan } from '../lib/Scheduler/feature/Pan.js';
export { default as ResourceMenu } from '../lib/Scheduler/feature/ResourceMenu.js';
export { default as ResourceTimeRanges } from '../lib/Scheduler/feature/ResourceTimeRanges.js';
export { default as RowReorder } from '../lib/Scheduler/feature/RowReorder.js';
export { default as RowResize } from '../lib/Scheduler/feature/RowResize.js';
export { default as ScheduleContext } from '../lib/Scheduler/feature/ScheduleContext.js';
export { default as ScheduleMenu } from '../lib/Scheduler/feature/ScheduleMenu.js';
export { default as ScheduleTooltip } from '../lib/Scheduler/feature/ScheduleTooltip.js';
export { default as SimpleEventEdit } from '../lib/Scheduler/feature/SimpleEventEdit.js';
export { default as Split } from '../lib/Scheduler/feature/Split.js';
export { default as StickyEvents } from '../lib/Scheduler/feature/StickyEvents.js';
export { default as Summary } from '../lib/Scheduler/feature/Summary.js';
export { default as TimeAxisHeaderMenu } from '../lib/Scheduler/feature/TimeAxisHeaderMenu.js';
export { default as TimelineSummary } from '../lib/Scheduler/feature/TimelineSummary.js';
export { default as TimeRanges } from '../lib/Scheduler/feature/TimeRanges.js';
export { default as TimeSelection } from '../lib/Scheduler/feature/TimeSelection.js';
// feature mixin
export { default as DependencyCreation } from '../lib/Scheduler/feature/mixin/DependencyCreation.js';
export { default as DependencyTooltip } from '../lib/Scheduler/feature/mixin/DependencyTooltip.js';
export { default as NonWorkingTimeMixin } from '../lib/Scheduler/feature/mixin/NonWorkingTimeMixin.js';
export { default as RecurringEventEdit } from '../lib/Scheduler/feature/mixin/RecurringEventEdit.js';
export { default as TaskEditStm } from '../lib/Scheduler/feature/mixin/TaskEditStm.js';
export { default as TaskEditTransactional } from '../lib/Scheduler/feature/mixin/TaskEditTransactional.js';
export { default as TransactionalFeature } from '../lib/Scheduler/feature/mixin/TransactionalFeature.js';
// export
export { default as MultiPageExporter } from '../lib/Scheduler/feature/export/exporter/MultiPageExporter.js';
export { default as MultiPageVerticalExporter } from '../lib/Scheduler/feature/export/exporter/MultiPageVerticalExporter.js';
export { default as PdfExport } from '../lib/Scheduler/feature/export/PdfExport.js';
export { default as Print } from '../lib/Scheduler/feature/export/Print.js';
export { default as ScheduleRangeCombo } from '../lib/Scheduler/view/export/field/ScheduleRangeCombo.js';
export { default as SchedulerExportDialog } from '../lib/Scheduler/view/export/SchedulerExportDialog.js';
export { default as SinglePageExporter } from '../lib/Scheduler/feature/export/exporter/SinglePageExporter.js';
export { ScheduleRange } from '../lib/Scheduler/feature/export/Utils.js';
// features experimental
export { default as ExcelExporter } from '../lib/Scheduler/feature/experimental/ExcelExporter.js';
// model
export { default as AssignmentModel } from '../lib/Scheduler/model/AssignmentModel.js';
export { default as DependencyBaseModel } from '../lib/Scheduler/model/DependencyBaseModel.js';
export { default as DependencyModel } from '../lib/Scheduler/model/DependencyModel.js';
export { default as EventModel } from '../lib/Scheduler/model/EventModel.js';
export { default as ProjectModel } from '../lib/Scheduler/model/ProjectModel.js';
export { default as RecurrenceModel } from '../lib/Scheduler/model/RecurrenceModel.js';
export { default as ResourceModel } from '../lib/Scheduler/model/ResourceModel.js';
export { default as ResourceTimeRangeModel } from '../lib/Scheduler/model/ResourceTimeRangeModel.js';
export { default as TimeRangeModel } from '../lib/Scheduler/model/TimeRangeModel.js';
export { default as TimeSpan } from '../lib/Scheduler/model/TimeSpan.js';
// model mixin
export { default as AssignmentModelMixin } from '../lib/Scheduler/model/mixin/AssignmentModelMixin.js';
export { default as EventModelMixin } from '../lib/Scheduler/model/mixin/EventModelMixin.js';
export { default as ProjectModelCommon } from '../lib/Scheduler/model/mixin/ProjectModelCommon.js';
export { default as ProjectModelMixin } from '../lib/Scheduler/model/mixin/ProjectModelMixin.js';
export { default as ProjectModelTimeZoneMixin } from '../lib/Scheduler/model/mixin/ProjectModelTimeZoneMixin.js';
export { default as RecurringTimeSpan } from '../lib/Scheduler/model/mixin/RecurringTimeSpan.js';
export { default as ResourceModelMixin } from '../lib/Scheduler/model/mixin/ResourceModelMixin.js';
export { default as TimeZonedDatesMixin } from '../lib/Scheduler/model/mixin/TimeZonedDatesMixin.js';
// preset
export { default as PresetManager } from '../lib/Scheduler/preset/PresetManager.js';
export { default as PresetStore } from '../lib/Scheduler/preset/PresetStore.js';
export { default as ViewPreset } from '../lib/Scheduler/preset/ViewPreset.js';
// tooltip
export { default as ClockTemplate } from '../lib/Scheduler/tooltip/ClockTemplate.js';
// util
export { default as RectangularPathFinder } from '../lib/Scheduler/util/RectangularPathFinder.js';
export { default as ScheduleTableExporter } from '../lib/Scheduler/util/ScheduleTableExporter.js';
//view
export { default as HorizontalTimeAxis } from '../lib/Scheduler/view/HorizontalTimeAxis.js';
export { default as TimeAxisSubGrid } from '../lib/Scheduler/view/TimeAxisSubGrid.js';
export { default as Scheduler } from '../lib/Scheduler/view/Scheduler.js';
export { default as SchedulerBase } from '../lib/Scheduler/view/SchedulerBase.js';
export { default as EventEditor } from '../lib/Scheduler/view/EventEditor.js';
export { default as TimeAxisViewModel } from '../lib/Scheduler/view/model/TimeAxisViewModel.js';
export { default as TimelineBase } from '../lib/Scheduler/view/TimelineBase.js';
export { default as ResourceHeader } from '../lib/Scheduler/view/ResourceHeader.js';
export { default as TimelineHistogramBase } from '../lib/Scheduler/view/TimelineHistogramBase.js';
export { default as TimelineHistogram } from '../lib/Scheduler/view/TimelineHistogram.js';
//view mixin
export { default as DelayedRecordsRendering } from '../lib/Scheduler/view/mixin/DelayedRecordsRendering.js';
export { default as Describable } from '../lib/Scheduler/view/mixin/Describable.js';
export { default as EventNavigation } from '../lib/Scheduler/view/mixin/EventNavigation.js';
export { default as EventSelection } from '../lib/Scheduler/view/mixin/EventSelection.js';
export { default as RecurringEvents } from '../lib/Scheduler/view/mixin/RecurringEvents.js';
export { default as SchedulerDom } from '../lib/Scheduler/view/mixin/SchedulerDom.js';
export { default as SchedulerDomEvents } from '../lib/Scheduler/view/mixin/SchedulerDomEvents.js';
export { default as SchedulerEventRendering } from '../lib/Scheduler/view/mixin/SchedulerEventRendering.js';
export { default as SchedulerRegions } from '../lib/Scheduler/view/mixin/SchedulerRegions.js';
export { default as SchedulerResourceRendering } from '../lib/Scheduler/view/mixin/SchedulerResourceRendering.js';
export { default as SchedulerScroll } from '../lib/Scheduler/view/mixin/SchedulerScroll.js';
export { default as SchedulerState } from '../lib/Scheduler/view/mixin/SchedulerState.js';
export { default as SchedulerStores } from '../lib/Scheduler/view/mixin/SchedulerStores.js';
export { default as TimelineDateMapper } from '../lib/Scheduler/view/mixin/TimelineDateMapper.js';
export { default as TimelineDomEvents } from '../lib/Scheduler/view/mixin/TimelineDomEvents.js';
export { default as TimelineEventRendering } from '../lib/Scheduler/view/mixin/TimelineEventRendering.js';
export { default as TimelineHistogramGrouping } from '../lib/Scheduler/view/mixin/TimelineHistogramGrouping.js';
export { default as TimelineHistogramScaleColumn } from '../lib/Scheduler/view/mixin/TimelineHistogramScaleColumn.js';
export { default as TimelineScroll } from '../lib/Scheduler/view/mixin/TimelineScroll.js';
export { default as TimelineState } from '../lib/Scheduler/view/mixin/TimelineState.js';
export { default as TimelineViewPresets } from '../lib/Scheduler/view/mixin/TimelineViewPresets.js';
export { default as TimelineZoomable } from '../lib/Scheduler/view/mixin/TimelineZoomable.js';
export { default as TransactionalFeatureMixin } from '../lib/Scheduler/view/mixin/TransactionalFeatureMixin.js';
// view orientation
export { default as HorizontalRendering } from '../lib/Scheduler/view/orientation/HorizontalRendering.js';
export { default as VerticalRendering } from '../lib/Scheduler/view/orientation/VerticalRendering.js';
//view recurrence
export { default as RecurrenceCombo } from '../lib/Scheduler/view/recurrence/field/RecurrenceCombo.js';
export { default as RecurrenceConfirmationPopup } from '../lib/Scheduler/view/recurrence/RecurrenceConfirmationPopup.js';
export { default as RecurrenceDaysButtonGroup } from '../lib/Scheduler/view/recurrence/field/RecurrenceDaysButtonGroup.js';
export { default as RecurrenceDaysCombo } from '../lib/Scheduler/view/recurrence/field/RecurrenceDaysCombo.js';
export { default as RecurrenceEditor } from '../lib/Scheduler/view/recurrence/RecurrenceEditor.js';
export { default as RecurrenceEditorPanel } from '../lib/Scheduler/view/recurrence/RecurrenceEditorPanel.js';
export { default as RecurrenceFrequencyCombo } from '../lib/Scheduler/view/recurrence/field/RecurrenceFrequencyCombo.js';
export { default as RecurrenceLegendButton } from '../lib/Scheduler/view/recurrence/RecurrenceLegendButton.js';
export { default as RecurrenceMonthDaysButtonGroup } from '../lib/Scheduler/view/recurrence/field/RecurrenceMonthDaysButtonGroup.js';
export { default as RecurrenceMonthsButtonGroup } from '../lib/Scheduler/view/recurrence/field/RecurrenceMonthsButtonGroup.js';
export { default as RecurrencePositionsCombo } from '../lib/Scheduler/view/recurrence/field/RecurrencePositionsCombo.js';
export { default as RecurrenceStopConditionCombo } from '../lib/Scheduler/view/recurrence/field/RecurrenceStopConditionCombo.js';
// widget
export { default as EventColorPicker } from '../lib/Scheduler/widget/EventColorPicker.js';
export { default as EventColorField } from '../lib/Scheduler/widget/EventColorField.js';
export { default as ProjectCombo } from '../lib/Scheduler/widget/ProjectCombo.js';
export { default as ResourceCombo } from '../lib/Scheduler/widget/ResourceCombo.js';
export { default as ResourceFilter } from '../lib/Scheduler/widget/ResourceFilter.js';
export { default as SchedulerDatePicker } from '../lib/Scheduler/widget/SchedulerDatePicker.js';
export { default as UndoRedo } from '../lib/Scheduler/widget/UndoRedo.js';
export { default as ViewPresetCombo } from '../lib/Scheduler/widget/ViewPresetCombo.js';


import GlobalEvents from '../lib/Core/GlobalEvents.js';
import BrowserHelper from '../lib/Core/helper/BrowserHelper.js';
import VersionHelper from '../lib/Core/helper/VersionHelper.js';
import Widget from '../lib/Core/widget/Widget.js';
import Toast from '../lib/Core/widget/Toast.js';
import Override from '../lib/Core/mixin/Override.js';
import DomHelper from '../lib/Core/helper/DomHelper.js';
import SchedulerBase from '../lib/Scheduler/view/SchedulerBase.js';
import HorizontalRendering from '../lib/Scheduler/view/orientation/HorizontalRendering.js';
import VerticalRendering from '../lib/Scheduler/view/orientation/VerticalRendering.js';
import Dependencies from '../lib/Scheduler/feature/Dependencies.js';
(() => {
    //region Common
    const
        HOSTS            = [
            'bryntum.com',
            'cdpn.io',
            'react-gantt.com',
            'vue-gantt.com',
            'vue-scheduler.com',
            'react-scheduler.com',
            'angular-scheduler.com',
            'angular-calendar.com',
            'vue-calendar.com',
            'react-calendar.com',
            'lmctfy.net'
        ],
        ONE_DAY          = 1000 * 60 * 60 * 24,
        EXPIRING_CLASSES = [];
    if (!VersionHelper.isTestEnv && (HOSTS.some(host => location.host.includes(host)) || /\/docs/.test(location.href))) {
        return;
    }
    let initialized;
    function initExpiryHelper(owner, baseClass) {
        if (!initialized) {
            initialized = true;
            ExpiryHelper.construct({
                widget : owner
            });
        }
        // do not remove this line (used to distinguish trial bundles by regexp)
        owner.__foo = 'THISISTRIAL';
    }
    //endregion
    //region ExpiryHelper
    class ExpiryHelper {
        static construct(config) {
            const
                me            = this,
                product       = 'gantt',
                productName   = 'Gantt',
                version       = VersionHelper.getVersion(product),
                callHomeDelay = VersionHelper.isTestEnv ? 3000 : 1000 * 60,
                blockUrl      = BrowserHelper.queryString.blockUrl;
            Object.assign(me, {
                version,
                product,
                Product          : productName,
                verifyUrl        : VersionHelper.isTestEnv ? blockUrl : 'https://bryntum.com/verify/',
                blocked          : false,
                lastVersionCheck : 0,
                trialKey         : `b-${product}-trial-start`,
                versionCheckKey  : `b-${product}-verify-date`
            }, config);
            if (!VersionHelper.isTestEnv) {
                console.log(`Bryntum ${productName} Trial Version`);
            }
            me.cacheTrialStartTime();
            if (me.isExpired) {
                if (document.readyState === 'complete') {
                    me.onTrialExpired();
                }
                else {
                    document.addEventListener('readystatechange', () => {
                        if (document.readyState === 'complete') {
                            me.onTrialExpired();
                        }
                    });
                }
            }
            // Call home to log trial usage, assuming localStorage access works reliably
            // 1 min delay to be less easily detected
            setTimeout(() => {
                me.updateBlockedStatus();
            }, callHomeDelay);
        }
        static cacheTrialStartTime() {
            const
                me         = this,
                timeString = BrowserHelper.getLocalStorageItem(me.trialKey),
                time       = Number(timeString);
            if (time && !isNaN(time)) {
                me.trialStartTime = time;
            }
            me.trialStartTime = me.trialStartTime || Date.now();
            // First trial access, or no localstorage (no local storage meaning our expiration mechanism won't work. Only remote blocking will end the trial)
            BrowserHelper.setLocalStorageItem(me.trialKey, me.trialStartTime);
        }
        static get isExpired() {
            return this.blocked || (Date.now() - this.trialStartTime > ONE_DAY * 45) || window.bryntum?.[this.product]?.expired;
        }
        static updateBlockedStatus() {
            const
                me                  = this,
                saveVersionCheckKey = () => BrowserHelper.setLocalStorageItem(me.versionCheckKey, Date.now());
            me.lastVersionCheck = me.lastVersionCheck || BrowserHelper.getLocalStorageItem(me.versionCheckKey) || 0;
            // Max 1 version check per session / day
            if (me.lastVersionCheck && Date.now() - me.lastVersionCheck < ONE_DAY) {
                return;
            }
            if (me.verifyUrl) {
                const
                    url    = encodeURIComponent(location.href),
                    logUrl = `${me.verifyUrl}?id=${window.bryntum.license}&url=${url}`,
                    img    = new Image();
                img.onload = () => {
                    // 2x2 image means trial is blocked due to violation
                    if (img.naturalWidth === 2) {
                        me.blockTrial();
                    }
                    else {
                        // Just in case
                        saveVersionCheckKey();
                    }
                };
                img.onerror = () => {
                    saveVersionCheckKey();
                };
                img.src = logUrl;
            }
            else {
                saveVersionCheckKey();
            }
        }
        static onTrialExpired() {
            const rootEl = this.widget.rootElement;
            if (!this.expirationShown) {
                this.expirationShown = true;
                if (!VersionHelper.isTestEnv) {
                    console.warn(`Bryntum ${this.Product} trial version expired. Purchase a license at https://bryntum.com/store or contact us at https://bryntum.com/contact/ for licensing options.`);
                }
                rootEl.floatRoot && Toast.show({
                    html        : `Psst! Your Bryntum ${this.Product} trial has expired. Please see <a href="https://bryntum.com/store">our store</a> for licensing options`,
                    timeout     : 20000,
                    rootElement : rootEl
                });
            }
            DomHelper.removeEachSelector(rootEl, '.b-sch-dependency');
            DomHelper.forEachSelector(rootEl, '.b-container', element => {
                const widget = Widget.fromElement(element, 'widget');
                if (EXPIRING_CLASSES.some(cls => widget instanceof cls)) {
                    this.maskExpiredWidget(widget);
                }
            });
        }
        static blockTrial() {
            this.blocked = true;
            // Get rid of version check timestamp
            BrowserHelper.removeLocalStorageItem(this.versionCheckKey);
            // To force expired state: Set a fake early trial timestamp
            BrowserHelper.setLocalStorageItem(this.trialKey, 1);
            this.onTrialExpired();
        }
        static maskExpiredWidget(widget) {
            widget.mask({
                text  : '<h3 style="margin:0">Trial expired, <a href="https://bryntum.com/store" style="margin:0 3px; color:inherit">click here</a> to buy a license.</h3>',
                icon  : 'b-fa b-fa-frown',
                type  : 'trial',
                cover : 'target'
            });
        }
        static setWaterMark(element, {
            darkColor = 'rgba(255, 255, 255, 0.03)',
            lightColor = 'rgba(240, 240, 240, 0.54)'
        } = {}) {
            // Used for thumbnails
            if (BrowserHelper.queryString.thumb != null) {
                return;
            }
            const
                color     = DomHelper.themeInfo?.name?.toLowerCase().endsWith('-dark') ? darkColor : lightColor,
                svgString = `
                   <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="100%" height="100%" style="font-family:sans-serif;font-weight:900;fill:${color}">
                    <defs>
                        <pattern id="company" patternUnits="userSpaceOnUse" width="400" height="200">
                            <text y="30" font-size="40" id="name">Bryntum</text>
                            <text y="120" x="200" font-size="24" id="trial">Trial Version</text>
                        </pattern>
                        <pattern id="pattern" xlink:href="#company" patternTransform="rotate(-45)">
                            <use xlink:href="#name" /><use xlink:href="#trial" />
                        </pattern>
                    </defs>
                    <rect width="100%" height="100%" fill="url(#pattern)" />
                </svg>`;
            element.style.backgroundImage = `url('data:image/svg+xml;base64,${window.btoa(svgString)}')`;
        };
    }
    //endregion
    //region Common override
    const applyBaseOverride = baseClass => {
        EXPIRING_CLASSES.push(baseClass);
        Override.apply(class {
            static get target() {
                return {
                    class : baseClass
                };
            }
            onPaintOverride() {
                const
                    me            = this,
                    setWatermarks = () => {
                        const targets = me.subGrids ? Object.values(me.subGrids) : [me];
                        for (const target of targets) {
                            if (target.element) {
                                ExpiryHelper.setWaterMark(target.element);
                            }
                        }
                    };
                initExpiryHelper(me, baseClass);
                setWatermarks();
                // React to theme changes
                GlobalEvents.on('theme', () => {
                    setWatermarks();
                });
                if (ExpiryHelper.isExpired) {
                    ExpiryHelper.maskExpiredWidget(me);
                }
            }
        });
    };
    //endregion
    if (typeof SchedulerBase !== 'undefined') {
        applyBaseOverride(SchedulerBase);
        // Disable rendering dependencies
        Override.apply(class {
            static get target() {
                return {
                    class : Dependencies
                };
            }
            domSync() {
                if (!ExpiryHelper.isExpired) {
                    return this._overridden.domSync.apply(this, arguments);
                }
            }
        });
        Override.apply(class {
            static get target() {
                return {
                    class : HorizontalRendering
                };
            }
            onRenderDone() {
                if (!ExpiryHelper.isExpired || this.scheduler?.isSchedulerPro) {
                    return this._overridden.onRenderDone.apply(this, arguments);
                }
            }
        });
        Override.apply(class {
            static get target() {
                return {
                    class : VerticalRendering
                };
            }
            onRenderDone() {
                if (!ExpiryHelper.isExpired || this.scheduler?.isSchedulerPro) {
                    return this._overridden.onRenderDone.apply(this, arguments);
                }
            }
        });
    }
})();
(() => {
    // do not load analytics code for specific domains
    const ignoreDomainRe = /(.force.com|.lightning.com|.salesforce.com|lmctfy.net|qa.bryntum.com|qa2.bryntum.com)/;
    // document location might be null in firefox in salesforce
    if (!document.location || ignoreDomainRe.test(document.location.href) || window.top !== window) {
        return;
    }
    let id;
    const websiteUrls = [
        'bryntum.com',
        'cdpn.io'
    ];
    const
        products   = ['calendar', 'grid', 'gantt', 'scheduler', 'schedulerpro', 'taskboard'],
        frameworks = ['angular', 'react', 'vue', 'ionic'];
    websiteUrls.splice(0, 0, ...products.map(prod => frameworks.map(framework => `${framework}-${prod}`)).concat('bryntum.com').flat());
    if (document.location.host.match(websiteUrls.join('|'))) {
        id = 'G-1VY6776VJP';
    }
    else {
        id = 'G-H465KZDH8S';
    }
    const newScript = document.createElement('script');
    newScript.onload = function() {
        window.dataLayer = window.dataLayer || [];
        function gtag() {
            window.dataLayer.push(arguments);
        }
        gtag('js', new Date());
        gtag('config', id);
    };
    document.head.appendChild(newScript);
    newScript.src = 'https://www.googletagmanager.com/gtag/js?id=' + id;
})();
